<ng-container *ngIf="viewModel$ | async as viewModel">
    <table *ngIf="viewModel.products.length" mat-table [dataSource]="viewModel.products" matSort (matSortChange)="onSort($event)" matSortDisableClear [matSortStart]="'desc'">
          <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
                <mat-checkbox appAuthorizeControl="edit||offermang" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [disabled]="!viewModel.products.length">
                </mat-checkbox>
            </th>
            <td class="no-ellipsis" mat-cell *matCellDef="let row">
                <mat-checkbox appAuthorizeControl="edit||offermang" (click)="getSelected(row);$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <!--  Image Column -->
        <ng-container matColumnDef="Image">
            <th style="width:8%" mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                Preview
            </th>
            <td mat-cell class="offer-image" *matCellDef="let row">
                <div class="image-cell"  [class.preselected]="row.IsFeaturedProduct">
                    <img mat-card-md-image
                    [src]="row.FacingAsset ? (row.FacingAsset | offerPreview: PreviewMode.Thumbnail) : './assets/images/default-image.png'" alt="Image" width="40" height="30">
                </div>                
            </td>
        </ng-container>

        <ng-container matColumnDef="Montage">
            <th style="width:7%" class="no-ellipsis" mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                Featured
            </th>
            <td style="align-items: center;" class="no-ellipsis" mat-cell *matCellDef="let row">
                <mat-checkbox [class.checked]="row.IsFeaturedProduct" [checked]="row.IsFeaturedProduct" (change)="onFeaturedChange($event.checked, row)">Featured</mat-checkbox>
            </td>
        </ng-container>

        <!-- ProductName Column -->
        <ng-container matColumnDef="ProductName">
            <th style="width:22%" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name" [resizeColumn]="true">
                Name
            </th>
            <td mat-cell *matCellDef="let record"> {{ record.Detail.ProductName }}</td>
        </ng-container>     

        <!-- Category Column -->
        <ng-container matColumnDef="ProductCategoryName">
            <th style="width:16%" mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                Category
            </th>
            <td mat-cell *matCellDef="let record">{{ record.ProductCategoryName }}</td>
        </ng-container>

        <!-- Brand Column -->
        <ng-container matColumnDef="ProductBrandName">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                Brand
            </th>
            <td mat-cell *matCellDef="let record">{{ record.ProductBrandName }}</td>
        </ng-container>

         <!-- Id Column -->
         <ng-container matColumnDef="Id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id" [resizeColumn]="true">
                Id
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.Id }}</td>
        </ng-container>

        <!-- ClientKey Column -->
        <ng-container matColumnDef="ClientKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ClientKey" [resizeColumn]="true">
                Client Key
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.ClientKey }}</td>
        </ng-container>

        <!-- Rank Column -->
        <ng-container matColumnDef="Rank">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Rank" [resizeColumn]="true">
                Rank
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Rank }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="Actions">
            <th appAuthorizeControl="admin||offermang" mat-header-cell *matHeaderCellDef>Actions</th>
            <td appAuthorizeControl="admin||offermang" mat-cell *matCellDef="let record">
                <a [routerLink]="[record.Detail.Id]" [queryParamsHandling]="'preserve'">Edit Rank</a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <table *ngIf="!viewModel.products.length">
        <tr>
            <td class="no-records" [attr.colspan]="displayedColumns.length">
                <h2>No Records Found</h2>
            </td>
        </tr>
    </table>

    <!-- pager -->
    <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)" *ngIf="viewModel.products.length"
        showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
    </mat-paginator>

</ng-container>
